<script>
import { ref } from 'vue'
import { CheckCircleIcon } from '@heroicons/vue/24/outline'
import { XMarkIcon } from '@heroicons/vue/20/solid'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default {
  name: 'TwNotification',
  components: { FontAwesomeIcon },
  emits: ['closed','shown'],
  data() {
    return {
      Show: false,
      Duration: 5,
      Message: null,
      Type: null
    }
  },
  computed: {
    themeConfiguration () {
      switch (this.Type) {
      case 'success':
        return {
          icon: 'check-circle',
          text_color: 'text-green-400'
        }
      case 'info':
        return {
          icon: 'info-circle',
          text_color: 'text-blue-400'
        }
      case 'warning':
        return {
          icon: 'triangle-exclamation',
          text_color: 'text-yellow-400'
        }
      case 'danger': case 'error':
        return {
          icon: 'circle-exclamation',
          text_color: 'text-red-400'
        }
      }

    }
  },
  watch: {
    Show() {
      if(this.Show) {
        setTimeout(() => {
          this.Show = false
        }, this.Duration*1000)
      }
    }
  },
  methods: {
    close() {
      this.Show = false
      this.$emit('closed')
    },
    show(message, type = 'success', duration = 5) {
      console.log('notification type: ', type)
      this.Duration = duration
      this.Message = message
      this.Type = type
      this.Show = true
      this.$emit('shown')
    }
  }
}
</script>

<template>
  <div aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-40">
    <div id="tw-notification-container" class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
      <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div v-if="Show" class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-40">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <font-awesome-icon :icon="themeConfiguration.icon" :class="'h-6 w-6 mt-1 ' + themeConfiguration.text_color" aria-hidden="true" />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <div class="text-sm font-medium text-gray-900">
                  <slot>
                    <span v-html="Message" />
                  </slot>
                </div>
              </div>
              <div class="ml-4 flex flex-shrink-0">
                <button type="button" class="inline-flex rounded-md bg-white  text-gray-400 hover:text-gray-900 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:ring-offset-2 transition-all duration-300 ease-in-out" @click="close">
                  <span class="sr-only">Close</span>
                  <font-awesome-icon icon="circle-xmark" class="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped>

</style>
